module.exports = __webpack_public_path__ + "static/img/desBcg.ae4f8360.webp";